const audioUrlRegex = /\.mp3\b/;
export const isAudioUrl = (url) => url && audioUrlRegex.test(url);
